import { IndexedDbDiagramStore } from '@/diagram-persistence/indexeddb-diagram-store';
import { IndexedDbAssetCache } from '@/pattern-persistence/asset-cache';
import { createPatternLocalStore } from '@/pattern-persistence/local-store';

export type OwnedCacheClearers = {
	clearDiagrams: () => Promise<void>;
	clearPatterns: () => Promise<void>;
	clearAssets: () => Promise<void>;
};

const defaultClearers = (): OwnedCacheClearers => ({
	clearDiagrams: () => new IndexedDbDiagramStore().clearAll(),
	clearPatterns: () => createPatternLocalStore().clearAll(),
	clearAssets: () => new IndexedDbAssetCache().clearAll(),
});

/** Wipes EVERY owner-stamped local cache. The single `azabu-diagrams-owner`
 *  stamp governs ALL synced caches (spec §3), so an account switch must
 *  clear all three IndexedDB databases no matter which store's prepare hook ran
 *  first — a diagrams-only wipe would claim the stamp and let the previous
 *  account's pattern documents and image blobs leak into (and re-upload under) the new one. */
export async function wipeAllOwnedCaches(deps: OwnedCacheClearers = defaultClearers()): Promise<void> {
	await deps.clearDiagrams();
	await deps.clearPatterns();
	await deps.clearAssets();
}
